import { Box } from '@mui/material';
import { useMemo } from 'react';

//generator
const generateSparkles = (count = 100) => {
    return Array.from({ length: count }).map(() => {
        const size = Math.random() * 15 + 10;

        const blurStart = size * 0.5;
        const blurEnd = size * 0.6;

        return {
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            size,
            opacity: 0.6 + Math.random() * 0.4,
            duration: `${Math.random() * 2 + 3}s`,
            dx: (Math.random() - 0.5) * 140,
            dy: (Math.random() - 0.5) * 140,
            blurStart,
            blurEnd,
        };
    });
};

export default function SparklesBackground() {
    const sparkles = useMemo(() => generateSparkles(40), []);

    return (
        <>
            {/* animation keyframes */}
            <Box
                sx={{
                    position: 'absolute',
                    inset: 0,
                    overflow: 'hidden',

                    '@keyframes flyToViewer': {
                        '0%': {
                            transform: 'scale(0.3)',
                            opacity: 0,
                            filter: 'blur(var(--blurStart))',
                        },
                        '20%': {
                            opacity: 1,
                        },
                        '100%': {
                            transform:
                                'translate3d(var(--dx), var(--dy), 0) scale(2.5)',
                            opacity: 0,
                            filter: 'blur(var(--blurEnd))',
                        },
                    },
                }}
            >
                {sparkles.map((s, i) => (
                    <Box
                        key={i}
                        sx={{
                            position: 'absolute',
                            top: s.top,
                            left: s.left,
                            width: s.size,
                            height: s.size,
                            borderRadius: '50%',
                            background: 'rgba(255, 200, 80, 0.9)',
                            opacity: s.opacity,

                            animation: 'flyToViewer linear infinite',
                            animationDuration: s.duration,

                            '--dx': `${s.dx}px`,
                            '--dy': `${s.dy}px`,
                            '--blurStart': `${s.blurStart}px`,
                            '--blurEnd': `${s.blurEnd}px`,

                            pointerEvents: 'none',
                        }}
                    />
                ))}
            </Box>
        </>
    );
}